import { useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router";
import ContentContainer from "shared/components/common/ContentContainer";
import useWindowDimensions from "shared/hooks/misc/useWindowDimensions";
import { Form, InputGroup } from "react-bootstrap";
import MFAModalComponent from "./MFAModalComponent";
import { useAppStore } from "App/store";
import MFAOptions from "./MFAOptions";
import {
  PageTitle,
  StyledSettings,
  StyledSettingsConfigurationSection,
  StyledSettingsContainer,
  StyledSettingsSection,
  StyledSettingsTitle,
  StyledSettingsTitleSection,
} from "./styled";
import {
  useMFADisable,
  useMFAEmailSendCode,
  useValidateMFAEmailCode,
  useEnableMFAEmail,
  useGetOPTQRCode,
  useConfirmOTPCode,
} from "shared/hooks/api/mfa";
import { useMeQuery } from "shared/hooks/api/contacts";
import { enableAndValidatingMFA } from "./MFAUtil";

function Settings() {
  const { height } = useWindowDimensions();
  const [contact] = useMeQuery();
  const [selectedValue, setSelectedValue] = useState(
    contact?.two_fa_type || MFAOptions.Disabled.value
  );
  const [disableMFA] = useMFADisable();
  const [sendMFAEmailCode] = useMFAEmailSendCode();
  const [validateMFAEmailCode] = useValidateMFAEmailCode();
  const [enableMFAEmail] = useEnableMFAEmail();
  const [qrCode, qrCodeURI] = useGetOPTQRCode();
  const [confirmCode] = useConfirmOTPCode();
  const [modalIsOpen, setModalIsOpen] = useState();

  const handleToggleModal = useCallback(() => {
    setModalIsOpen((prev) => !prev);
  }, [setModalIsOpen]);
  const location = useLocation();
  const { appState } = useAppStore();
  useEffect(() => {
    if (
      appState.isAuth &&
      contact?.enforce_mfa_for_portal &&
      (!selectedValue || selectedValue === MFAOptions.Disabled.value)
    ) {
      setModalIsOpen(true);
    }
    return () => setModalIsOpen(false);
  }, [
    location,
    contact?.enforce_mfa_for_portal,
    selectedValue,
    appState.isAuth,
  ]);

  const handleRadioChange = async (
    val,
    verifyCodeInputClass = "qbenchVerifyCode"
  ) => {
    enableAndValidatingMFA({
      MFAType: val,
      qrCode,
      qrCodeURI,
      setSelectedValue,
      validateMFAEmailCode,
      verifyCodeInputClass,
      disableMFA,
      sendMFAEmailCode,
      enableMFAEmail,
      confirmCode,
    });
  };
  return (
    <StyledSettings>
      <PageTitle>Settings</PageTitle>
      <ContentContainer
        style={{ borderRadius: 16, padding: "30px", height: height * 0.8 }}
      >
        <StyledSettingsContainer>
          <StyledSettingsSection>
            <StyledSettingsTitleSection>
              <StyledSettingsTitle>
                Multi-Factor Authentication
              </StyledSettingsTitle>
              <small>Enable/Disable your Multi-Factor Authentication</small>
            </StyledSettingsTitleSection>
            <StyledSettingsConfigurationSection>
              <Form>
                <Form.Group>
                  {Object.keys(MFAOptions).map((option) => {
                    const { label, value } = MFAOptions[option];
                    return (
                      <InputGroup key={value}>
                        <Form.Check
                          type="radio"
                          label={label}
                          name="mfa"
                          value={value}
                          checked={selectedValue === value}
                          onChange={(e) => handleRadioChange(e.target.value)}
                        />
                      </InputGroup>
                    );
                  })}
                </Form.Group>
              </Form>
            </StyledSettingsConfigurationSection>
            <MFAModalComponent
              modalIsOpen={modalIsOpen}
              setModalIsOpen={setModalIsOpen}
              handleToggleModal={handleToggleModal}
              handleRadioChange={handleRadioChange}
            />
          </StyledSettingsSection>
        </StyledSettingsContainer>
      </ContentContainer>
    </StyledSettings>
  );
}

export default Settings
